import React from 'react';

const Chip = ({ label, onRemove }) => {
  return (
    <div className="combobox-selected">
      <span className="combobox-selected-label" title={label}>{label}</span>
      
      <button className="clear-btn bg-transparent align-items-center" type="button" aria-label="Delete selected option" onClick={onRemove}>
        <span className="close" />
      </button>
    </div>
  );
};

export default Chip;
